// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { useScanProxyApiClient } from '../../../contexts/ScanProxyApiContext';

const useDsoParty: () => UseQueryResult<string, string> = () => {
  const scanProxyApi = useScanProxyApiClient();

  return useQuery({
    queryKey: ['getDsoPartyId', scanProxyApi],
    queryFn: async () => {
      const response = await scanProxyApi.getDsoPartyId();

      return response.dso_party_id;
    },
    refetchInterval: false,
  });
};

export default useDsoParty;
